import { TourStep } from '@/hooks/useTour';

// Three-moment first run. Herds, buddies, achievements and messaging are taught
// contextually via FirstUseTip the first time a member opens those areas.
export const tourSteps: TourStep[] = [
  {
    id: 'welcome',
    type: 'showcase',
    title: "Welcome to Wellness Cowgirl! 🤠",
    description: "More than an event finder — it's your community",
    route: "/",
    highlightTab: 'home',
    showcaseSlides: [
      {
        id: 'welcome',
        title: 'Welcome!',
        description: "San Antonio's wellness community — events, buddies and Herds in one place",
        component: 'welcome',
      },
    ],
  },
  {
    id: 'your-preferences',
    type: 'showcase',
    title: "Built Around You 🌟",
    description: "Your interests, area and availability shape what you see",
    highlightTab: 'events',
    showcaseSlides: [
      {
        id: 'event-types',
        title: 'More Than Just Yoga',
        description: 'Movement, mindset, nutrition, pop-ups and social — matched to your preferences',
        component: 'event-types',
      },
    ],
  },
  {
    id: 'first-event',
    type: 'showcase',
    title: "Find Your First Event",
    description: "Here's what's coming up near you",
    cta: { label: "Browse events", route: "/events" },
    route: "/events",
    highlightTab: 'events',
    showcaseSlides: [
      {
        id: 'find-event',
        title: 'Find Your First Event',
        description: 'Pick one that fits your week — you can always bring a buddy',
        component: 'event-card',
      },
    ],
  },
];
